import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, toObservable, nextToPromise, createSelector } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { TarifaPagoChoferForm } from "./form";
import * as rx from "rxjs";

const TarifaPagoChoferFormRx = componentToRx(TarifaPagoChoferForm);
type Entity = models.TarifaPagoChofer;
const resource = resources.TarifaPagoChofer;

interface Props {
    match: match<{ id: string }>
}
interface State {
    value?: Entity;
}



class TarifaPagoChoferEditComp extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }
    idStr = (props: Props, state: State) => this.props.match.params.id;
    id = createSelectorRx(this.idStr, id => id == "new" ? "new" : Number.parseInt(id));
    esNuevo = createSelectorRx(this.id, id => id == "new");
    nuevoValue = (props: Props, state: State) => ({
        Porcentajes: {}
    } as Entity)

    valueFromResource = createSelectorRx(this.id, id => observeResource(resources.TarifaPagoChofer.get, id));

    valueFromState = (props: Props, state: State) => state.value;
    value = createSelector(this.valueFromState, this.valueFromResource, this.esNuevo, this.nuevoValue , (state, resource, esNuevo, nuevo) => state ? rx.Observable.from([state]) : esNuevo ? rx.Observable.from([nuevo]) : resource);

    onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));
    onGuardar = async () => {
        const id = this.id(this.props, this.state);
        const func = id == "new" ? resource.add : resource.update;
        const value = await nextToPromise(this.value(this.props, this.state));
        await func(value);
        history.go("../");
    }

    render() {
        const value = this.value(this.props, this.state);
        const id = this.id(this.props, this.state);
        return <TarifaPagoChoferFormRx
            value={value}
            onChange={this.onChange}
            nuevo={id == "new"}
            onGuardar={this.onGuardar} />;
    }
}

export const TarifaPagoChoferEdit = withRouter(TarifaPagoChoferEditComp);


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/tarifapagochofer/edit/edit.tsx